// Libs
import React from 'react';
// Components
import ilustration from './illustration.svg';

const PreferencesPopup = ({ width = '200px' }) => {
	return <img src={ilustration} style={{ width }} />;
};

export default PreferencesPopup;
